import type {ITimeoutService, IWindowService} from 'angular';
import type {StateService} from '@uirouter/angularjs';

/**
 * @ngdoc service
 * @name reloader
 * @module portaro.services
 *
 * @description
 * Factory provides reloading features
 */
export default class ReloaderService {
    public static serviceName = 'reloader';

    /*@ngInject*/
    constructor(private $window: IWindowService, private $timeout: ITimeoutService, private $state: StateService) {
    }

    /**
     * @ngdoc method
     * @name reloader#reload
     * @deprecated Use {@link reloader#reloadRoute} if you don't need to do full page reload.
     * Otherwise, use {@link reloader#reloadPage}
     *
     * @description
     * Reloads whole page
     */
    public reload(timeout?: number) {
        this.reloadPage(timeout);
    }

    /**
     * @ngdoc method
     * @name reloader#reloadPage
     *
     * @description
     * Does full page reload
     */
    public reloadPage(timeout?: number) {
        if (angular.isDefined(timeout)) {
            this.$timeout(() => this.$window.location.reload(), timeout);
        } else {
            this.$window.location.reload();
        }
    }

    /**
     * @ngdoc method
     * @name reloader#reloadRoute
     *
     * @description
     * Reloads only the current route of SPA router without whole page reload
     */
    public async reloadRoute(): Promise<void> {
        await this.$state.reload();
    }
}
